var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-cascader',{ref:"cascader",attrs:{"options":_vm.options,"props":_vm.props,"collapse-tags":"","clearable":""},on:{"change":_vm.menuchange,"remove-tag":_vm.removeTag},model:{value:(_vm.checkedArray),callback:function ($$v) {_vm.checkedArray=$$v},expression:"checkedArray"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }